import { getGameById } from "../../api/game";
import { modalWait } from "../../utils/logger";
import {
	updateStats,
	updateTimer,
	getTimer,
	setLastTickNow,
} from "../../utils/helpers";
import { ROUTES } from "../../utils/constants";

/**
 * Antes en Scenario1Instructions: validar juego, actualizar stats/timer y permitir ir a /scenarios.
 * @returns {Promise<boolean>} true si debe navegarse a la pantalla de escenarios
 */
export async function scenario1ProceedToScenariosBoard({ game, group }) {
	const res = await getGameById(game?._id);
	if (res.status !== 200) {
		return false;
	}

	const gameData = res.data;

	if (!gameData.active && !gameData.demo) {
		try {
			await modalWait({
				html: `<div class="d-flex flex-column">
						<div>El juego aún no ha empezado.</div>
						<div class="mt-2">Espera a que el moderador dé la orden</div>
						</div>`,
			});
		} catch (_) {
			// modal cancelado / error
		}
		return false;
	}

	const alreadyStarted = getTimer() !== null;

	if (alreadyStarted) {
		await updateStats({
			...group,
			lastVisited: ROUTES.TRANSITION_SCENARIOS,
		});
	} else {
		const time = group?.time ? parseInt(group.time, 10) : 0;
		updateTimer(time);
		setLastTickNow();

		await updateStats({
			...group,
			actualScenario: 1,
			time: 0,
			lastVisited: ROUTES.TRANSITION_SCENARIOS,
		});
	}

	return true;
}
